<template>
  <div>
    <div class="header">
      <div class="header-wrap">
        <router-link to="/">
          <img src="faviconsq.ico" class="header-icon">
          <span class="icon-text">CSLab.</span>
        </router-link>

        <div v-if="isSp" class="menu">
          <div class="menu-button button" @click="toggleMenu">
            <img class="menu-icon" src="menu.png">
          </div>
          <transition>
            <div v-if="isMenuOpened" @click="toggleMenu">
              <router-link to="/" >
                <div class="menu-item">研究室について</div>
              </router-link>
              <router-link to="/member">
                <div class="menu-item">メンバー</div>
              </router-link>
              <router-link to="/work">
                <div class="menu-item">研究成果</div>
              </router-link>
              <router-link to="/access">
                <div class="menu-item header-item">
                  アクセス
                </div>
              </router-link>
            </div>
          </transition>
        </div>

        <div v-else class="menu-flex">
          <router-link to="/">
            <div class="menu-item header-item">
              研究室について
            </div>
          </router-link>
          <router-link to="/member">
            <div class="menu-item header-item">
              メンバー
            </div>
          </router-link>
          <router-link to="/work">
            <div class="menu-item header-item">
              研究成果
            </div>
          </router-link>
          <router-link to="/access">
            <div class="menu-item header-item">
              アクセス
            </div>
          </router-link>
        </div>

      </div>
    </div>
    <div class="content-over" v-if="isMenuOpened" @click="toggleMenu"></div>
    <div class="header-margin"></div>
  </div>
</template>

<script>
  export default {
    components: {
    },
    data () {
      return {
        isMenuOpened: false
      }
    },
    computed: {
      isSp() { return window.innerWidth < 500},
    },
    methods: {
      toggleMenu() {
        this.isMenuOpened = !this.isMenuOpened
      }
    }
  }
</script>

<style scoped>
  a {
    text-decoration: none;
  }
  a:visited {
    color: #333;
  }

  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 1;
    box-shadow: 0 2px 8px #f5f5f5;
  }

  .header-margin {
    height: 8em;
  }

  .header-wrap {
    margin: 0 auto;
    padding: 1em 1.5em;
    max-width: 800px;
    line-height: 2em;
    display: flex;
    justify-content: space-between;
  }

  .header-icon {
    width: 29px;
    height: 29px;
  }

  .icon-text {
    text-align: left;
    padding-left: .5em;
    font-size: 1.2em;
    font-weight: bold;
  }

  .menu {
    text-align: right;
    overflow: hidden;
  }

  .menu-flex {
    display: flex;
  }

  .menu-icon {
    width: 32px;
    height: 32px;
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  .menu-button {
    width: 36px;
    height: 36px;
  }

  .button {
    border: none;
    border-radius: 32px;
    position: relative;
    margin: 0 0 0 auto;
  }

  .button:after {
    content: "　";
    border: none;
    background: white;
    border-radius: 32px;
    width: 36px;
    height: 36px;
    opacity: 0;

    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: -1;
  }

  .button:active:after {
    filter: brightness(95%);
    opacity: 1;
  }

  .menu-item {
    padding: 0 1em;
    padding: .5em 1em 0 1em;
    color: #333;
    background: #fff;
    z-index: 1;
  }

  .header-item:hover {
    filter: brightness(95%);
  }

  .menu-item:active {
    filter: brightness(90%);
  }

  .content-over {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #333;
    opacity: .4;
    z-index: 0;
  }

  .v-enter,
  .v-leave-to {
    height: 0px;
  }

  .v-enter-to,
  .v-leave {
    height: 160px;
  }

  .v-enter-active,
  .v-leave-active {
    transition: height .2s
  }
</style>
